import script from "./dingDingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./dingDingDetails.vue?vue&type=script&setup=true&lang=js"

import "./dingDingDetails.vue?vue&type=style&index=0&id=32c5213d&lang=scss&scoped=true"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c5213d"]])

export default __exports__